package com.kinoshazam.data

import com.russhwolf.settings.Settings

actual class Storage(settings: Settings) {

    val delegate = StorageImpl(settings)

    actual inline fun <reified DataType> put(key: String, value: DataType) {
        delegate.put(key, value)
    }

    actual inline fun <reified DataType> get(key: String): DataType? {
        return delegate.get(key)
    }

    actual inline fun <reified DataType> get(key: String, default: DataType): DataType {
        return delegate.get(key, default)
    }

    actual fun clear() = delegate.clear()

    actual fun remove(key: String) = delegate.remove(key)
}
